var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "menu_schedules--schedule" }, [
    _c("div", { staticClass: "menu_schedules--schedule__header" }, [
      _c("h3", [_vm._v(_vm._s(_vm.normalizedSchedule.schedule_title))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "menu_schedules--schedule_body" }, [
      _c("div", { staticClass: "menu_schedules--schedule_body_item" }, [
        _c("span", [_vm._v("Applies To:")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.scheduleAppliesToMenuTypes))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu_schedules--schedule_body_item" }, [
        _c("span", [_vm._v("Start Date/Time")]),
        _vm._v(" "),
        _vm.normalizedSchedule.schedule_start_datetime
          ? _c("span", [
              _vm._v(_vm._s(_vm.normalizedSchedule.schedule_start_datetime)),
            ])
          : _c("span", [_vm._v("No Limitation")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu_schedules--schedule_body_item" }, [
        _c("span", [_vm._v("End Date/Time")]),
        _vm._v(" "),
        _vm.normalizedSchedule.schedule_end_datetime
          ? _c("span", [
              _vm._v(_vm._s(_vm.normalizedSchedule.schedule_end_datetime)),
            ])
          : _c("span", [_vm._v("No Limitation")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }